export default __webpack_public_path__ + "static/media/investment-acquisition-1.ad452046.svg";